
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Edit, ErrorOutline, Check, InfoOutlined as InfoIcon } from '@material-ui/icons';
import { Grid, Typography, Stepper, Step, StepLabel, StepConnector, LinearProgress, Button, Tooltip } from '@material-ui/core';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import _ from 'lodash';
import { MyPATCollapse } from '../../common';
import { statusType } from '../types/ContentInSection'
import ContentData from '../types/ContentData';
import contentService from '../services/contentService';
import ContentPublishedModal from './ContentPublishedModal';
import ACLService from '../../acl/services/aclService';
import { notesMaterial } from '../types/ContentInSection';
import { showMsg } from '../../course/actions/loaderAlert';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { CONTENT_STATES, OBJECTIVE_NOTES } from '../../../constants/comman';
import { notePayload, setAddConceptAndChapter } from '../helper/notesPayload';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import classNames from 'classnames';
import { scrollIntoView } from '../../../utils';
import { Attachment } from '../../common/MyPATUploader';
import * as LZString from 'lz-string';
import * as JSLZString from 'lz-string';
import PerfectScrollbar from 'react-perfect-scrollbar';

const styles = (theme: Theme) =>
  createStyles({
    active: {
      color: theme.palette.error.light,
    },
    successIcon: {
      backgroundColor: "#379D0B",
    },
    primaryColor: {
      backgroundColor: theme.palette.primary.main,
    },
    warningIcon: {
      color: "#FF4A4A !important",
      padding: "0 !important",
      transform: "scale(1.3)",
    },
    positionAb: {
      position: "absolute",
      right: "5px",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
    },
    publishedLabel: {
      position: "absolute",
      right: "0",
      left: "0",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
      cursor: "pointer",
    },
    positionRl: {
      position: "relative",
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 13,
      padding: "3px",
      fontSize: 28,
    },
    editIcon: {
      fontSize: 16,
    },
    defaultIcon: {
      backgroundColor: theme.palette.primary.contrastText,
    },
    p15: {
      //padding: theme.spacing.unit * 2,
      height: "auto",
      overflow: "auto",
    },
    overflowSection: {
      overflow: "auto",
      height: "auto",
      padding: theme.spacing.unit * 2,
      backgroundColor: '#fbfbfb',
    },
    innerConnecter: {
      "&:after": {
        minHeight: "32px",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        margin: "21px -10px -5px",
        borderColor: "#BDBDBD",
        content: '""',
        marginTop: "20px",
        position: "absolute",
      },
    },
    progressBar: {
      height: "20px",
      background: "#EDEDED",
      // borderRadius: "18px",
      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.193756)",
      minHeight: "33px",
      lineHeight: "33px",
      verticalAlign: "middle",
    },
    addOptionButton: {
      textAlign: "center",
    },
    moveToPlannedContainer: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit,
      marginLeft: -theme.spacing.unit * 2,
      marginRight: -theme.spacing.unit * 2,
      //paddingLeft: theme.spacing.unit * 2,
      //paddingRight: theme.spacing.unit * 2,
      position: "relative",
      borderTop: "1px solid #ededed",
    },
    moveToPlannedOr: {
      position: "absolute",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      fontSize: "12px",
      background: "#ededed",
      color: "#adadad",
      //padding: theme.spacing.unit,
      borderRadius: "100%",
    },
    moveToPlanned: {
      borderRadius: "18px",
      width: "100%",
      marginTop: theme.spacing.unit * 4,
    },
    modalBody: {
      width: "900px",
      paddingBottom: "47px",
      paddingTop: "35px",
      textAlign: "center",
    },
    publishText: {
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "center",
      width: "577px",
      margin: "20px auto 0 auto",
      display: "block",
    },
    quesIdContainer: {
      padding: "15px",
      width: "100%",
      textAlign: "center",
    },
    quesId: {
      border: "solid 1px #2196F3",
      color: "#2196F3",
      padding: "5px 14px 5px 14px",
      textAlign: "center",
      fontSize: "16px",
      lineHeight: "16px",
      borderRadius: "4px",
      textDecoration: "none",
      margin: "10px",
      background: "#ffffff",
    },
    modalFooter: {
      textAlign: "center",
      padding: "10px 0 20px 0",
    },
    refreshBtn: {
      color: "#ffffff",
      padding: "0 16px",
      background: "linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      backgroundColor: "#2E93FB",
      border: "solid 1px #2E93FB",
      display: "inline-block",
      width: "140px",
    },
    okBtn: {
      color: "#2E93FB",
      padding: "0 16px",
      background: "#ffffff",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      marginLeft: "18px",
      display: "inline-block",
      width: "140px",
      border: "solid 1px #2E93FB",
    },
    newsteps: {
    //   borderLeft: "solid 1px #bdbdbd",
      padding: "10px 0 0 25px",
      margin: "0px 0 0 10px",
      backgroundColor: '#fbfbfb',
    },
    borderLeftNew: {
      content: "",
      background: "#bdbdbd",
      position: "absolute",
      left: "-38px",
      top: "12px",
      width: "10px",
      "z-index": "7",
      height: "1px",
      display: "inline-block",
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: "15px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      display: "grid",
      gridTemplateColumns: "89% 11%",
      alignItems: "center",
      "& button": {
        padding: "10px 8px",
        maxWidth: 140,
        width: "100%",
      },
    },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: "4px 8px",
      backgroundColor: "#E8E8E8",
      width: "82px",
      minWidth: 85,
      display: "inline-block",
      verticalAlign: "middle",
    },
    progressPercent: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    colorSecondary: {
      backgroundColor: "#EB4F4F",
      color: "5.5px 5px 5px 5.5px",
    },
    colorprimary: {
      backgroundColor: "#67BF02",
    },
    colorSuccess: {
      backgroundColor: "#67BF02",
      color: "5.5px 5px 5px 5.5px",
    },
    progressLabel: {
      fontSize: 14,
      color: "#999",
    },
    progressCount: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    progressParent: {
      display: "flex",
      alignItems: "center",
    },
    displayFlex: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row-reverse",
      maxWidth: 235,
      width: "100%",
      marginLeft: "auto",
    },
    cursorPointer: {
      cursor: "pointer",
    },
    numberLabel: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: "1px solid #dcdcdc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    connectorLine: {
      borderColor: "transparent",
      margin: "0px -2px 0px",
      //minHeight:'100%',
    },
    focusedStep: {
      backgroundColor: '#FAFCFF',
      padding: '10px 10px 10px 0',
      borderRadius: "4px",    
    },
    clickable: {
      cursor: 'pointer !important'
    },
    statusContent:{
      height:"81vh"
    }
  });

//@ts-ignore
interface SectionsInContentWithProps extends WithStyles<typeof styles> {
    classes: any,
    match: any,
    history: any,
    queryParams: any,
    notesData: any,
    handleNotesData: Function,
    notesSubTypes: any,
    content: ContentData,
    moveToPlanned: Function,
    publishContent: Function,
    fromURL: any,
    showMsg: any,
    focusedSection: { currentlyFocusedSection: string; sectionsTouched: Set<string> };
    notesPdfAttachment:Attachment []
}

interface SectionsInContentWithStates {
    inContent: any,
    isPageLoaded: boolean,
    previousEventInContent: any,
    inSubTypes: any,
    isPublishedDialogOpen: boolean,
    selectedAuthors: any,
    questionId: any,
    draft100Percent: any,
    draftLessThan100Percent: any,
    rePublishContentId: string,
}

class SectionsInContentStudyMaterial extends Component<SectionsInContentWithProps, SectionsInContentWithStates>{
    timerHandler: any = 0;
    updateTimer: any = 0;
    constructor(props: SectionsInContentWithProps, state: SectionsInContentWithStates) {
        super(props);
        // TODO remove unnecessary state later 
        this.state = {
            inContent: [],
            isPageLoaded: true,
            inSubTypes: [],
            //This will help for setTimeOut
            previousEventInContent: {},
            isPublishedDialogOpen: false,
            selectedAuthors: [],
            questionId: "",
            draft100Percent: [],
            draftLessThan100Percent: [],
            rePublishContentId: '',
        };
        this.publishContent = this.publishContent.bind(this);
    }

    componentDidMount() {
        this.generateContentType();
        //FIXME: Remember to uncomment this
        this.timerHandler = setInterval(() => {
            let { previousEventInContent } = this.state;
            if (previousEventInContent) {
                previousEventInContent.keyName = "";
            }
        }, 17000)

    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (!_.isEqual(this.props.notesSubTypes, prevState.inContent)) {
            
            this.setState({
                isPageLoaded: true,
            }, () => this.generateContentType());

        }
        // if(!_.isEqual(this.props.activeTab, prevProps.activeTab)) {
        //   console.log(this.props.activeTab)
        //   let pdfInContent = JSON.parse(JSON.stringify(this.state.inContent))
        //   if(this.props.activeTab === "Upload PDF") {
        //     pdfInContent[0].subType = [{
        //       'key': "createNotes",
        //       'state': 2,
        //       'title': "Upload PDF",
        //       'visible': true
        //       }]
        //   } else {
        //     pdfInContent[0].subType = [{
        //       'key': "createNotes",
        //       'state': 2,
        //       'title': "Page 1",
        //       'visible': true
        //       }]
        //   }

        //   this.setState({inContent: pdfInContent})
        // }
    }

    generateContentType = () => {
        if (this.state.isPageLoaded) {
          
            this.setState({
                inContent: [...this.props.notesSubTypes],
                isPageLoaded: false,
            }, () => {
                this.props.handleNotesData({
                    completionPercent: this.calCulateProgressBar(
                        this.state.inContent
                    ).barPercentage
                })
            })
        }
    };

    getHeaderForSection() {
        let { subType, type } = this.props.queryParams;

        switch (`${subType}_${type}`) {
            case 'notes_studymaterial':
                return { header: notesMaterial.map(o => o.title), keys: notesMaterial.map(o => o.key), isNested: true }
        }
    }
    getSectionId = (sectionLabel: string,) => {
      let id = _.camelCase(sectionLabel)
      return id;
    }

  onSectionClick = (sectionLabel: string) => {

    let formatted = (this.formatSectionId(_.camelCase(sectionLabel)))

    formatted = formatted.includes('page') ? 'createNotes-'+formatted : formatted;

    scrollIntoView(formatted);
  }

    checkIfCurrentlyEditing = (sectionId: string) => {
      
      const { focusedSection: { currentlyFocusedSection } } = this.props;
      const splitted = this.formatSectionId(currentlyFocusedSection).split('-');

      return splitted.includes(_.camelCase(sectionId))
    }

  formatSectionId(sectionId: string) {
    return sectionId.replace('PracticeSet', 'Notes').replace('question', 'page');
  }

    stepLabelType(label: string, type: statusType, sectionNo: number, subSectionNo: number | string = ''): any {
        let { classes, focusedSection: { currentlyFocusedSection } } = this.props;
        let sectionId = this.getSectionId(label);
        const isCurrentlyEditing = this.checkIfCurrentlyEditing(this.formatSectionId(sectionId));
      // if (type != statusType.none) {
            return (<StepLabel className={classNames(classes.clickable, isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label)} icon={this.stepLevelIconType(type, sectionNo, subSectionNo, isCurrentlyEditing)}><Typography variant="body1" style={{position:'relative'}}>{label}</Typography></StepLabel>)
        // }
        // else {
        //     console.log({ label, type, sectionNo, subSectionNo })
        //     return (<StepLabel className={classNames(classes.clickable, isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label)}><Typography variant="body1">{label}</Typography></StepLabel>)
        // }
    }


    stepLevelIconType(type: statusType, sectionNo: number, subSectionNo: number | string, isCurrentlyEditing: boolean) {
        let { classes } = this.props;
        let toShow = (sectionNo + 1).toString();
        if (subSectionNo !== '') {
            toShow = (parseInt(subSectionNo.toString()) + 1).toString()
        }
        if(isCurrentlyEditing) {
          return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
        }
        switch (type) {
            // case statusType.edit:
            //     return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
            // case statusType.warning:
            //     return (<ErrorOutline className={`${classes.icon} ${classes.warningIcon}`} />)
            case statusType.success:
                return (<Check className={`${classes.icon} ${classes.successIcon}`} />)
            default:
              return (<Typography className={classes.numberLabel} variant="body1">{toShow}</Typography>)
        }
    }

    getButtonName() {
        const { content } = this.props;
        let status = 'Publish';
            if (["PUBLISHED"].includes(content.status)) {
                    status = 'Re-Publish';
            }
            return status;
    }

    togglePublishDialogOpen = () => this.setState({ isPublishedDialogOpen: false })

    getPageNumber = (key: any): any => {
        const extractNumber = key.replace(/^\D+/g, '');
        return extractNumber;
    }

    pagesInArrayForm = (pageState: any) => {
        let filterPages: any = [];
        Object.keys(pageState).map((key: any) => {
            filterPages.push({ ...pageState[key] });
        });
        return filterPages;
    }

    getNotesData = async (pages: any) => {
        const { notesData,notesPdfAttachment } = this.props;
        const { attempt = {},activeTab, pdfUrl } =notesData;
        let copyNotesData = setAddConceptAndChapter(notesData);
        delete copyNotesData.pageState;
        delete copyNotesData.pageError;
        delete copyNotesData.attempt;
        delete copyNotesData.activeTab;
        delete copyNotesData.pdfUrl;
        const pageKeyName = Object.keys(notesData.pageState);
        let attachment: any = pdfUrl;
        if(notesPdfAttachment && notesPdfAttachment.length > 0 ) {
          attachment = notesPdfAttachment
        } 
        let finalPayLoad:any =activeTab==="Upload PDF"? await notePayload(pages, pageKeyName, attempt,attachment): await notePayload(pages, pageKeyName, attempt);
      if (typeof (attachment) === 'string' && !_.isEmpty(attachment)) {
          finalPayLoad[0].metaData.pdf.code = copyNotesData.content.pages[0].metaData.pdf.code;
          finalPayLoad[0].metaData.pdf.key = copyNotesData.content.pages[0].metaData.pdf.key;
        }
        copyNotesData = { ...copyNotesData, pages: finalPayLoad };
        return new Promise((res,rej)=>{
                 return res(copyNotesData)}
                );
    }

    publishContent=async (usersSelected: any, mode: 'PUBLISH' | 'REPUBLISH')=>{
        const { notesData, content } = this.props;
        let { subType } = this.props.queryParams;
        let filteredNotesData: any = {}
        if (subType === 'notes') {
            const { pageState = {} } = notesData;
            const filteredPages = this.pagesInArrayForm(pageState);
            filteredNotesData =await this.getNotesData([...filteredPages]);
        }
        let authors: any = [];
        filteredNotesData.authors = authors;
        filteredNotesData.completionPercent = 100;
        filteredNotesData.status = "PUBLISHED";
        filteredNotesData._id = content.content_Id;
        if (filteredNotesData && filteredNotesData.pages && filteredNotesData.pages.length) {
          if (notesData.pdfType === 'WorkBook') {
            filteredNotesData.pages[0].subType = 'WORKBOOK';
          } else {
            filteredNotesData.pages[0].subType = '';
          }
        }
        //filteredNotesData.pages =filteredNotesData.content.pages;
        if (!notesData.title) {
            this.props.showMsg('Note title is required', 'error')
        }
        else if (notesData && notesData.pageError && notesData.pageError.title) {
            this.props.showMsg(notesData.pageError.title, 'error');
        }
        else {
            contentService
                .save(content.content_Id + 'note', 'studymaterial', filteredNotesData, false).
                then((response: any) => {
                    const res = response.responseObject.note || {}
                    if (res.draftId || res.publishId) {
                        filteredNotesData.draftId = res.draftId;
                        filteredNotesData.publishId = res.publishId;
                    }


                    if (mode === 'PUBLISH') {
                        contentService
                            .publish(filteredNotesData, usersSelected, 'note')
                            .then((res) => {
                                this.setState({
                                    questionId: content.content._id,
                                    isPublishedDialogOpen: true,
                                    rePublishContentId: res.contentId,
                                    // isAuthorDialogOpen: false
                                })
                            })
                    } else {
                        contentService
                            .rePublish(filteredNotesData, usersSelected, 'note', true)
                            .then((res: any) => {
                                this.setState({
                                    isPublishedDialogOpen: true,
                                    questionId: notesData._id,
                                    rePublishContentId: res.contentId,
                                    // isAuthorDialogOpen: false
                                });
                            });
                    }
                })
            this.setState({ selectedAuthors: authors });
        }
    }

    checkAccessToPublish = () => {
        const { content } = this.props;
        return content.status === CONTENT_STATES.DRAFT
    }

    publishButtonCustomStyle = (progressBarSetting: any) => {
        const style = { color: 'white', cursor: 'default', opacity: 0.6 }
        if (progressBarSetting.barPercentage >= 100) {
            if (this.checkAccessToPublish()) {
                style.cursor = "pointer"
                style.opacity = 1
            }
        }
        return style;
    }

    publishButtonOnClick = (progressBarSetting: any) => {
        if (progressBarSetting.barPercentage >= 100) {
            if (this.checkAccessToPublish()) {
                this.publishContent([], 'PUBLISH')
            }
            else {
                this.publishContent([], 'REPUBLISH')
            }

        }
    }

    calCulateProgressBar = (validations: any) => {
        const progressBarSetting: any = {}
        let sucess = 0;
        let total = 0;
        validations && validations.length && validations.forEach((key: any) => {
            total += 1
            if (key.state == statusType.success) {
                sucess += 1
            }
        })

        
        progressBarSetting.barPercentage = ((sucess / total) * 100).toFixed(2)
        // TODO - looking like we can remove bar length in future 
        progressBarSetting.barLength = parseInt(progressBarSetting.barPercentage)
            ;
        return progressBarSetting;
        // this.props.completionPercent(this.props.formData, progressBarSetting.barLength);
    }

    render() {
        const {
            classes,
            history,
            queryParams,
            content,
            fromURL,
        } = this.props;
        const {
            rePublishContentId,
            isPublishedDialogOpen,
            selectedAuthors,
            questionId,
            inContent
        } = this.state;
        const progressBarSetting = this.calCulateProgressBar(this.state.inContent);
        return (
          <PerfectScrollbar className={classes.statusContent}>
            {/* <MyPATCollapse title={<Typography component="h3" variant="body2">Sections in This Content */}
            {/* <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Sections in This Content"
                    imageURL="/assets/svg/infoIcon/createQuestion/window.svg"
                    dialogPara="All the sections should be filled in order to publish the Question/ Test."
                    details="Click to know more"
                    toolTipDirection="top" />
            </Typography>}> */}
            <Stepper
              className={classes.overflowSection}
              connector={
                <StepConnector
                  classes={{
                    disabled: classes.stepDisabled,
                    line: classes.connectorLine,
                  }}
                />
              }
              orientation="vertical"
            >
              {inContent.map((label: any, index: any) => (
                <Step key={index}>
                  {this.stepLabelType(label.title, label.state, index)}
                  {_.map(label.subType, (ob, i) => {
                    if (ob && ob.visible) {
                      return (
                        <Stepper
                          key={`${index}_${i}`}
                          className={classes.newsteps}
                          orientation="vertical"
                        >
                          <Step key={`${i}_${index}`}>
                            {this.stepLabelType(ob.title, ob.state, index, i)}
                            {/* <b style={{ content:'',
                                                        background: '#E4E4E4',
                                                        position:'absolute',
                                                        left:'-38px',
                                                        top:'12px',
                                                        width:'10px',
                                                        'z-index' : '7',
                                                        height:'1px',
                                                        display:'inline-block',}}>
                                                    </b> */}
                          </Step>
                        </Stepper>
                      );
                    }
                  })}
                </Step>
              ))}
            </Stepper>
            {/* <div
              onClick={() => {
                this.publishButtonOnClick(progressBarSetting);
              }}
              className={classes.positionRl}
            > */}
            {/* <LinearProgress
                classes={{ root: classes.progressBar }}
                variant="determinate"
                value={progressBarSetting.barLength}
              /> */}
            {/* <Typography
                className={classes.positionAb}
                variant="subtitle1"
                align="center"
              > */}
            {/* TODO - make it more readble  */}
            {/* {progressBarSetting.barLength > 0 ? (
                  progressBarSetting.barLength >= 100 ? (
                    <Check
                      className={`${classes.icon} ${
                        classes.successIcon
                      }`}
                    />
                  ) : (
                    `${progressBarSetting.barPercentage}%`
                  )
                ) : (
                  "0%"
                )}
              </Typography> */}
            {/* <div>
                <Typography
                  style={this.publishButtonCustomStyle(
                    progressBarSetting
                  )}
                  className={classes.publishedLabel}
                  variant="subtitle1"
                  align="center"
                >
                  {this.getButtonName()}
                </Typography>
              </div> */}
            {/* <Typography variant="caption" align="center">
                Reach 100% progress to publish the content
              </Typography> */}
            {/* </div> */}
            {isPublishedDialogOpen && (
              <ContentPublishedModal
                publishId={content.contentId}
                rePublishContentId={rePublishContentId}
                isPublishedDialogOpen={isPublishedDialogOpen}
                content={content}
                queryParams={queryParams}
                history={history}
                fromURL={fromURL}
                togglePublishDialogOpen={this.togglePublishDialogOpen}
                authors={selectedAuthors}
                questionId={questionId}
              />
            )}
            <Grid container className={classes.footerFixed}>
              <Grid item>
                <Grid className={classes.displayFlex}>
                  <LinearProgress
                    classes={{
                      colorSecondary: classes.colorprimary,
                      barColorPrimary: classes.colorprimary,
                      bar: classes.progressBar,
                      root: classes.linearProgressBar,
                    }}
                    variant="determinate"
                    value={progressBarSetting.barLength}
                  />
                  <Typography
                    //   className={classes.positionAb}
                    //   variant="subtitle1"
                    align="center"
                  >
                    {/* Progress: {progressBarSetting.barPercentage} % */}
                    Progress: {Math.round((parseFloat(progressBarSetting.barPercentage) || 0) * 100) / 100} %

                  </Typography>
                  
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={progressBarSetting.barPercentage < 100}
                  onClick={() => {
                    this.publishButtonOnClick(progressBarSetting);
                  }}

                >
                    {this.getButtonName()}
                  {/* {!this.props.fromFeedback
                    ? this.hasAccessToPublished()
                    : this.getButtonText("testpapers")} */}
                </Button>
              </Grid>
            </Grid>
            {/* </MyPATCollapse> */}
          </PerfectScrollbar>
        );
    }

}
const mapStateToProps = (state: any) => {
    return {
        notesSubTypes: _.get(state, 'studyNotedReducers', []),
        focusedSection: state.commonData.focusedSection,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    showMsg: showMsg,
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SectionsInContentStudyMaterial));